import React from "react";
import styled from "styled-components";
import { Link as RouterLink } from "react-router-dom"; // For internal routing
import CloseIcon from "../../Assets/images/logo.png"; // Your CloseIcon asset
import LogoIcon from "../../Assets/images/logo.png";

export default function Sidebar({ sidebarOpen, toggleSidebar }) {
  return (
    <Wrapper sidebarOpen={sidebarOpen}>
      {/* Sidebar Header */}
      <SidebarHeader className="flexSpaceCenter">
        <div className="flexNullCenter">
          <img
            src={LogoIcon}
            alt="Logo"
            style={{
              width: "80px",
              height: "60px",
              marginRight: "10px",
            }}
          />
          <h1 className="whiteColor font20" style={{ marginLeft: "15px" }}>
            Onify Digital Consultancy
          </h1>
        </div>
        <CloseBtn onClick={() => toggleSidebar(!sidebarOpen)}>
          <CloseIcon />
        </CloseBtn>
      </SidebarHeader>

      {/* Navigation Links */}
      <NavList>
        <li>
          <RouterLink
            to="/"
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="navLink"
          >
            Home
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/about"
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="navLink"
          >
            About Us
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/services"
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="navLink"
          >
            Services
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/booking"
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="navLink"
          >
            Booking
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/reviews"
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="navLink"
          >
            Blogs & Resources
          </RouterLink>
        </li>
        <li>
          <RouterLink
            to="/contact"
            onClick={() => toggleSidebar(!sidebarOpen)}
            className="navLink"
          >
            Contact Us
          </RouterLink>
        </li>
      </NavList>

      {/* Call-to-Action */}
      <CTAWrapper>
        <RouterLink
          to="/services"
          onClick={() => toggleSidebar(!sidebarOpen)}
          className="ctaButton"
        >
          Get Started
        </RouterLink>
      </CTAWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.nav`
  width: 300px;
  height: 100vh;
  position: fixed;
  top: 0;
  right: ${(props) => (props.sidebarOpen ? "0" : "-300px")};
  z-index: 9999;
  transition: right 0.3s ease-in-out;
  background-color: #222; /* Matches the dark theme */
  color: #fff;
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.2);
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SidebarHeader = styled.div`
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CloseBtn = styled.button`
  background: none;
  border: none;
  color: #fff;
  cursor: pointer;
  font-size: 24px;
`;

const NavList = styled.ul`
  list-style: none;
  padding: 20px;
  margin: 0;

  li {
    margin: 15px 0;

    .navLink {
      color: #fff;
      text-decoration: none;
      font-size: 16px;
      font-weight: 500;
      padding: 10px;
      display: block;
      transition: color 0.2s;

      &:hover {
        color: #ff7518; /* Matches the button theme */
      }
    }
  }
`;

const CTAWrapper = styled.div`
  margin: 20px;
  text-align: center;

  .ctaButton {
    display: inline-block;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: bold;
    color: #fff;
    background-color: #ff7518;
    border-radius: 25px;
    text-decoration: none;
    transition: background-color 0.3s;

    &:hover {
      background-color: #e56715;
    }
  }
`;
